import apiClient from "../../../utilities/apiClient";
import LocalStorage from "../../../utilities/localStorage";

export const createbank = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  return apiClient.post(
    user.roles[0] === "user"
      ? `${apiClient.Urls.create_bank}`
      : `${apiClient.Urls.add_bank_officer}`,
    payload,
    true,
    "file"
  );
};

export const editbankThunk = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.create_bank}/update`,
    payload,
    true,
    "file"
  );
};

export const countriesApi = (payload) => {
  return apiClient.get(`${apiClient.Urls.countries_get}`, payload, true);
};
export const currenciesAPI = (payload) => {
  return apiClient.get(`${apiClient.Urls.currency_get}`, payload, true);
};

export const statesApi = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.states_get}?countryId=${payload}`,
    payload,
    true
  );
};

export const banksApi = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  return apiClient.get(
    `${apiClient.Urls.bankinformation}/${user.user_id}`,
    payload,
    true
  );
};
export const banksApiIdWise = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.bankinformation}?id=${payload}`,
    "",
    true
  );
};

export const removeBankApi = (payload) => {
  var user = LocalStorage.getItem("tata_login_user").roles[0];
  const { vid, bank_id, reason } = payload;
  return apiClient.delete(
    user === "user"
      ? `${apiClient.Urls.delete_bank}/${bank_id}`
      : `${apiClient.Urls.admindeleteBankinformation}/${bank_id}`,
    { vid, reason },
    true
  );
};

export const validateBank = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  return apiClient.post(
    user.roles[0] === "user"
      ? `${apiClient.Urls.validateIFSC}`
      : `${apiClient.Urls.validate_ifsc_officer}`,
    payload,
    true
  );
};
